export default {
  // Alerts
  alerts: {
    // Info Alert
    info_alert: {
      title: "Нема достапни податоци",
      description: "Lab Portal не можеше да ги преземе бараните информации.",
    },
  },
};
